module.exports = __webpack_public_path__ + "static/img/nodata-icon.7f7cd6eb.png";